<template>
  <ContentWrapper class="hero mb-10" fluid>
    <div class="position-relative background pb-6" :class="'bg_' + bgType">
      <v-container class="pa-0pt-lg-16 pb-16 position-relative" :fluid="isSafari">
        <v-row class="h-40" justify="start" align-content="start">
          <v-col cols="12" lg="6" class="pt-9 pt-md-6 pt-xl-10">
            <h1 class="pb-9" :class="bgType == 'purple' ? 'text-white' : ''">
              {{ title1 }}
            </h1>

            <div :class="bgType == 'purple' ? 'text-white' : ''" v-html="sanitizeHtml(text)" />
          </v-col>
          <v-col
            cols="6"
            class="d-none d-lg-flex position-relative pt-16"
            :class="xlAndUp ? 'justify-center' : 'justify-end'">
            <v-img
              class="mt-8 position-absolute"
              :width="xlAndUp ? '70%' : '90%'"
              rounded="lg"
              cover
              :src="
                image ? `https://epd.zentek.dev/assets/${image}?format=webp&quality=80` : undefined
              " />
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-container class="pa-0 mt-10" :fluid="isSafari">
      <v-row>
        <v-col cols="12">
          <v-row class="d-flex flex-row">
            <v-col
              v-for="claim in claims"
              :key="claim"
              class="font-weight-bold py-2 claims text-left"
              cols="12"
              md="auto">
              <v-icon class="text-primary">custom:checklist</v-icon>
              <span class="pl-4 claim">{{ claim }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </ContentWrapper>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'
import { sanitizeHtml } from '~/util/sanitizer'
const { xlAndUp } = useDisplay()
const { isSafari } = useDevice()

const props = defineProps<{
  title1: string
  claims: string[]
  text: string | null
  bgType: string | null
  image: string | null
}>()

const { title1, text, bgType, image, claims } = props
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  overflow: visible;
}

.bg_blue {
  background: #d6ecff;
  background: linear-gradient(180deg, rgba(214, 236, 255, 1) 0%, rgba(241, 249, 255, 1) 100%);
}

.bg_purple {
  background: #5834e5;
  background: linear-gradient(90deg, rgba(88, 52, 229, 1) 0%, rgba(108, 143, 245, 1) 100%);
}
</style>
